module.exports = __webpack_public_path__ + "img/sb-gz.fd20c2c4.svg";